import { Link } from "react-router-dom";
import { Play, X, CheckSquare } from "lucide-react";

/**
 * Floating action tray shown at the bottom of list pages while items are selected.
 * Renders nothing when the set is empty. Calls `onStart` to persist the queue
 * and navigate to the first item — parent owns the navigation target so we
 * can reuse this tray for pitman / legal / typing.
 */
export default function SelectionTray({
  count,
  onStart,
  onClear,
  moduleLabel = "practice",
  firstHref,
}) {
  if (!count) return null;
  return (
    <div
      className="fixed left-1/2 -translate-x-1/2 bottom-6 z-40 flex items-center gap-3 px-4 py-3 rounded-2xl bg-[#0F172A] text-white shadow-2xl border border-brand-gold/40 backdrop-blur"
      data-testid="selection-tray"
      role="toolbar"
    >
      <div className="flex items-center gap-2 pr-3 border-r border-white/15">
        <CheckSquare className="w-4 h-4 text-brand-gold" />
        <span className="font-mono text-sm font-black" data-testid="selection-tray-count">
          {count}
        </span>
        <span className="text-[10px] uppercase tracking-widest font-bold text-white/60">
          selected
        </span>
      </div>
      <Link
        to={firstHref}
        onClick={onStart}
        data-testid="selection-tray-start"
        className="inline-flex items-center gap-1.5 px-4 h-9 rounded-lg bg-gradient-to-r from-[#E5C158] to-[#D4AF37] hover:from-[#D4AF37] hover:to-[#B8860B] text-[#0F172A] text-[11px] uppercase tracking-widest font-black transition-colors"
      >
        <Play className="w-3.5 h-3.5" fill="currentColor" /> Start {moduleLabel} queue
      </Link>
      <button
        type="button"
        onClick={onClear}
        data-testid="selection-tray-clear"
        className="inline-flex items-center justify-center w-8 h-8 rounded-lg hover:bg-white/10 text-white/70 hover:text-white transition-colors"
        title="Clear selection (Esc)"
        aria-label="Clear selection"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
